var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade-sidebar"}},[(!_vm.showSidebar)?_c('aside',{staticClass:"sidebar col"},[_c('div',{staticClass:"sidebar-bg"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }